import type {
  CSSProperties,
  ElementType,
  MouseEventHandler,
  ReactNode,
} from "react";
import { styled } from "@monolith-forensics/monolith-ui";

interface ItemChipProps {
  className?: string;
  text: ReactNode;
  Icon?: ElementType;
  onClick?: MouseEventHandler<HTMLDivElement>;
  onMouseEnter?: MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: MouseEventHandler<HTMLDivElement>;
  title?: string;
  style?: CSSProperties;
  iconStyle?: CSSProperties;
}

const noop = () => {};

const ItemChipContainer = styled.div`
  padding: 0 4px;
  font-size: 11px;
  color: ${(props) => props.theme.palette.text.secondary};
  border: 1px solid ${(props) => props.theme.palette.divider};
  border-radius: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: fit-content;
  min-width: fit-content;

  .item-chip-icon {
    font-size: 11px;
    margin-right: 5px;
  }
`;

const ItemChip = ({
  className,
  text,
  Icon,
  onClick = noop,
  onMouseEnter = noop,
  onMouseLeave = noop,
  title = "",
  style,
  iconStyle,
}: ItemChipProps) => {
  return (
    <ItemChipContainer
      className={className}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      title={title}
      style={style}
    >
      {Icon && <Icon className="item-chip-icon" style={iconStyle} />}
      <div>{text}</div>
    </ItemChipContainer>
  );
};

export default ItemChip;
